import { useState } from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSesion } from './sesion';
import { Ingreso } from './paginas/Ingreso';
import { Inicio } from './paginas/Inicio';
import { VistaConciliacion } from './paginas/VistaConciliacion';
import { Administracion } from './paginas/Administracion';
import { PanelControl } from './paginas/PanelControl';

export function App() {
  const { usuario, cargando, salir, puede } = useSesion();
  const { pathname } = useLocation();
  const [errorSalir, setErrorSalir] = useState('');

  // `void salir()` se tragaba el error: si el logout fallaba, el boton no
  // hacia nada y el usuario se iba creyendo que habia cerrado sesion.
  async function cerrarSesion() {
    setErrorSalir('');
    try {
      await salir();
    } catch (e) {
      setErrorSalir(e instanceof Error ? e.message : 'No se pudo cerrar la sesión.');
    }
  }

  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!usuario) return <Ingreso />;

  const ROL: Record<string, string> = {
    operador: 'Operador', supervisor: 'Supervisor', auditor: 'Auditor (solo lectura)',
  };

  return (
    <>
      <header className="app">
        <div>
          <h1>Conciliación de Tarjetas <span>· MULTIEMPRESAS</span></h1>
          <p>Resumen del emisor · mayor contable · control</p>
        </div>
        <div className="sesion">
          <b>{usuario.nombre}</b>
          {ROL[usuario.rol]}
          <div>
            <button className="btn-ghost" style={{ marginTop: 6, fontSize: 12, padding: '5px 10px' }}
                    onClick={() => void cerrarSesion()}>
              Salir
            </button>
          </div>
        </div>
      </header>

      <div className="wrap">
        {errorSalir && <div className="aviso bad" role="alert">{errorSalir}</div>}
        <nav className="tabs">
          <Link to="/" className={`tab ${pathname === '/' ? 'activa' : ''}`}>Conciliaciones</Link>
          <Link to="/control" className={`tab ${pathname === '/control' ? 'activa' : ''}`}
                style={{ background: pathname === '/control' ? '#fff' : '#fdf0c4',
                         color: pathname === '/control' ? 'var(--blue)' : '#5a4300',
                         fontWeight: 800, borderColor: '#e0a800' }}>
            CONTROL
          </Link>
          {puede('supervisor', 'operador') && (
            <Link to="/admin" className={`tab ${pathname.startsWith('/admin') ? 'activa' : ''}`}>
              Administración
            </Link>
          )}
        </nav>

        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/conciliacion/:id" element={<VistaConciliacion />} />
          <Route path="/control" element={<PanelControl />} />
          <Route path="/admin" element={<Administracion />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </>
  );
}
